import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ReferralDailyReport,
  ReferralDailyReportRequest,
  ReferralReportExportResponse,
  ReferralWeeklyReport,
  ReferralWeeklyReportRequest,
} from '../../Models/ReferralReport';

@Injectable({
  providedIn: 'root',
})
export class ReferralReportsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getDailyReport(payload: ReferralDailyReportRequest): Observable<ReferralDailyReport> {
    return this.http.post<ReferralDailyReport>(`${this.apiUrl}/referrals/reports/daily`, payload);
  }

  getWeeklyReport(payload: ReferralWeeklyReportRequest): Observable<ReferralWeeklyReport> {
    return this.http.post<ReferralWeeklyReport>(`${this.apiUrl}/referrals/reports/weekly`, payload);
  }

  exportDailyReport(payload: ReferralDailyReportRequest): Observable<ReferralReportExportResponse> {
    return this.http.post<ReferralReportExportResponse>(`${this.apiUrl}/referrals/reports/daily/export`, payload);
  }

  exportWeeklyReport(payload: ReferralWeeklyReportRequest): Observable<ReferralReportExportResponse> {
    return this.http.post<ReferralReportExportResponse>(`${this.apiUrl}/referrals/reports/weekly/export`, payload);
  }
}
